import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { selectAuthUserId } from '@app/reducers/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { map } from 'rxjs';

import { EmployeeOverviewService } from '../services/employee-overview.service';

export const canActivateEmployeeOverview: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const employeeOverview = inject(EmployeeOverviewService);
  const store = inject(Store<AppState>);
  const authUserId = store.selectSignal(selectAuthUserId);

  const employeeId = route.params['id'] || authUserId();

  // If data is already loaded, allow access immediately
  if (employeeOverview.isDataLoaded(employeeId)) {
    return true;
  }

  // Load data and allow access after loading
  return employeeOverview.loadEmployeeData(employeeId).pipe(map(() => true));
};
